import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, interval, map, Subscription } from 'rxjs';
import { isCloudInMaintenance, isUnauthenticatedPublicRoute, MAINTENANCE_POLLING_INTERVAL_MS } from '../conf/maintenance';
import { AppState } from '../store/app.reducer';
import * as AuthActions from '../store/auth/auth.actions';
import * as TaskActions from '../store/task/task.actions';
import { selectStatusData } from '../store/task/task.selector';

@Injectable({
	providedIn: 'root',
})
export class MaintenancePollingService implements OnDestroy {
	private pollingSub?: Subscription;
	private statusSub?: Subscription;

	constructor(
		private store: Store<AppState>,
		private router: Router,
	) { }

	start(): void {
		this.stop();
		this.pollServiceStatus();
		this.pollingSub = interval(MAINTENANCE_POLLING_INTERVAL_MS).subscribe(() => {
			this.pollServiceStatus();
		});
		this.statusSub = this.store.select(selectStatusData).pipe(
			map(statusData => statusData?.Status),
			distinctUntilChanged(),
		).subscribe(status => {
			if (isCloudInMaintenance(status) && !isUnauthenticatedPublicRoute(this.router.url)) {
				this.store.dispatch(AuthActions.authLogout());
			}
		});
	}

	stop(): void {
		this.pollingSub?.unsubscribe();
		this.statusSub?.unsubscribe();
	}

	ngOnDestroy(): void {
		this.stop();
	}

	private pollServiceStatus(): void {
		this.store.dispatch(TaskActions.getServiceStatus());
	}
}
